import React, { useState, useEffect, useRef } from 'react'
import { Form, Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { InfoCard2 } from '../../widgets/components/UI/InfoCard2'
import { Link } from 'react-router-dom'
import Closebtn from '../../../../media/shared-access/ic-close2.svg'
import Edit from '../../../../media/shared-access/edit.svg'
// import Delete from '../../../../media/shared-access/delete.svg'
import Delete from '../../../../media/shared-access/ic-delete.svg'
import { SwitchAccount } from '../components/switch-account'
import '../style/calendar.scss'
import { useAuth } from '../../auth'
import { getEvents, createEvent } from '../core/_requests'
import { toast } from 'react-toastify'
import { getUserInfo, deleteEvent, updateEvent, getMailers } from '../core/_requests'
//import DeleteModal from '../components/delete-confirmation'
import { getUserTimezone } from '../core/_requests'
import EditableDropdownInput from '../components/editableDropdownInput'
import { PageTitle } from '../../../../_metronic/layout/core'
import { SharedAccessBreadCrum } from '../core/_constants'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import brandingConfig from '../../../../config/brandingConfig'

const convertHtmlToPlainText = (html: any) => {
  const doc = new DOMParser().parseFromString(html, 'text/html')
  console.log('in html', doc.body.textContent, html)
  return (html && doc.body?.textContent) || ''
}

const convertToLocalTime = (unixTimestamp: any, timeFormat: any) => {
  let date = new Date(unixTimestamp * 1000)

  // Adjust for timezone offset if specified
  if (timeFormat.includes('UTC')) {
    const [hoursOffset, minutesOffset] = timeFormat?.split('+')[1].split(':').map(Number)
    date.setHours(date.getHours() + hoursOffset)
    date.setMinutes(date.getMinutes() + minutesOffset)
  }

  const isoString = date.toISOString()
  const dateString = isoString.split('T')[0]
  const timeString = isoString.split('T')[1].split('.')[0]

  return { date: dateString, time: timeString }
}

const convertToUnixEpoch = (dateString: string) => {
  const date = new Date(dateString)
  return Math.floor(date.getTime() / 1000)
}

function debounce<T extends (...args: any[]) => any>(func: T, wait: number) {
  let timeout: ReturnType<typeof setTimeout> | null
  return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
    if (timeout) clearTimeout(timeout)
    timeout = setTimeout(() => func.apply(this, args), wait)
  }
}

const timeOptions = [
  '12:00 AM',
  '12:15 AM',
  '12:30 AM',
  '12:45 AM',
  '1:00 AM',
  '1:15 AM',
  '1:30 AM',
  '1:45 AM',
  '2:00 AM',
  '2:15 AM',
  '2:30 AM',
  '2:45 AM',
  '3:00 AM',
  '3:15 AM',
  '3:30 AM',
  '3:45 AM',
  '4:00 AM',
  '4:15 AM',
  '4:30 AM',
  '4:45 AM',
  '5:00 AM',
  '5:15 AM',
  '5:30 AM',
  '5:45 AM',
  '6:00 AM',
  '6:15 AM',
  '6:30 AM',
  '6:45 AM',
  '7:00 AM',
  '7:15 AM',
  '7:30 AM',
  '7:45 AM',
  '8:00 AM',
  '8:15 AM',
  '8:30 AM',
  '8:45 AM',
  '9:00 AM',
  '9:15 AM',
  '9:30 AM',
  '9:45 AM',
  '10:00 AM',
  '10:15 AM',
  '10:30 AM',
  '10:45 AM',
  '11:00 AM',
  '11:15 AM',
  '11:30 AM',
  '11:45 AM',
  '12:00 PM',
  '12:15 PM',
  '12:30 PM',
  '12:45 PM',
  '1:00 PM',
  '1:15 PM',
  '1:30 PM',
  '1:45 PM',
  '2:00 PM',
  '2:15 PM',
  '2:30 PM',
  '2:45 PM',
  '3:00 PM',
  '3:15 PM',
  '3:30 PM',
  '3:45 PM',
  '4:00 PM',
  '4:15 PM',
  '4:30 PM',
  '4:45 PM',
  '5:00 PM',
  '5:15 PM',
  '5:30 PM',
  '5:45 PM',
  '6:00 PM',
  '6:15 PM',
  '6:30 PM',
  '6:45 PM',
  '7:00 PM',
  '7:15 PM',
  '7:30 PM',
  '7:45 PM',
  '8:00 PM',
  '8:15 PM',
  '8:30 PM',
  '8:45 PM',
  '9:00 PM',
  '9:15 PM',
  '9:30 PM',
  '9:45 PM',
  '10:00 PM',
  '10:15 PM',
  '10:30 PM',
  '10:45 PM',
  '11:00 PM',
  '11:15 PM',
  '11:30 PM',
  '11:45 PM',
]

const timeToDate = (timeStr: any) => {
  const [time, period] = timeStr.split(' ')
  const [hours, minutes] = time.split(':').map(Number)
  const isPM = period === 'PM'
  const adjustedHours = isPM ? (hours % 12) + 12 : hours % 12
  return new Date(1970, 0, 1, adjustedHours, minutes)
}

const dateToTime = (date: any) => {
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const period = hours >= 12 ? 'PM' : 'AM'
  const adjustedHours = hours % 12 || 12
  return `${adjustedHours}:${minutes.toString().padStart(2, '0')} ${period}`
}

const timeToDateFormat = (timeStr: string) => {
  const [time, period] = timeStr.split(' ')
  let [hours, minutes] = time.split(':').map(Number)
  if (period === 'PM' && hours !== 12) {
    hours += 12
  } else if (period === 'AM' && hours === 12) {
    hours = 0
  }
  const date = new Date()
  date.setHours(hours, minutes, 0, 0)
  return date
}

// Helper function to convert Date object to time string in 12-hour format
const dateToTimeFormat = (date: Date): string => {
  const options: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true, // Ensures AM/PM is included
  }

  // Create a formatter to ensure AM/PM is uppercase
  const formatter = new Intl.DateTimeFormat(brandingConfig.defaultLocale, options)
  let formattedTime = formatter.format(date)

  // Ensure AM/PM is uppercase
  formattedTime = formattedTime.toUpperCase()

  return formattedTime
}

const getTimeDifferenceString = (minutes: number) => {
  if (minutes < 60) {
    return `${minutes} mins`
  } else {
    const hours = (minutes / 60).toFixed(1)
    return `${hours} hours`
  }
}

const getEndTimes = (startDateStr: string, endDateStr: string, startTimeStr: string) => {
  const startDate = new Date(startDateStr)
  const endDate = new Date(endDateStr) // eslint-disable-line
  const startTime: any = timeToDateFormat(startTimeStr)

  const endTimes = []
  const initialEndTime: any = new Date(startDate)
  initialEndTime.setHours(startTime.getHours(), startTime.getMinutes(), 0, 0)

  let endTime: any = new Date(initialEndTime)

  if (startDateStr === endDateStr) {
    while (endTime - initialEndTime < 23 * 60 * 60 * 1000) {
      endTime.setMinutes(endTime.getMinutes() + 30)

      console.log('end time one', endTime)
      const formattedEndTime = dateToTimeFormat(endTime)

      console.log('end time', formattedEndTime)
      const diffMinutes = (endTime - initialEndTime) / (1000 * 60)
      const diffString = getTimeDifferenceString(diffMinutes)
      endTimes.push(`${dateToTime(endTime)} (${diffString})`)
    }
  } else {
    endTime = new Date(startDate)
    endTime.setHours(0, 0, 0, 0)
    while (endTime.getDate() === startDate.getDate()) {
      endTime.setMinutes(endTime.getMinutes() + 30)
      endTimes.push(dateToTime(endTime))
    }
  }

  return endTimes
}

const roundToNearest15Minutes = (date: any) => {
  const minutes = 15
  const ms = 1000 * 60 * minutes
  return new Date(Math.ceil(date.getTime() / ms) * ms)
}

export default function Calendar() {
  const { companyId } = useAuth()
  const { formatMessage } = useIntl()
  const [userInfo, setuserInfo] = useState('')
  const [addEventModal, setAddEventModal] = useState(false)
  const [eventInfo, setEventInfo] = useState(false)
  const [eventData, seteventData] = useState({})
  const [isUserConnected, setisUserConnected] = useState(false)
  const [accountType, setaccountType] = useState('')
  const [userLoading, setuserLoading] = useState(false)
  const [connectorLoading, setconnectorLoading] = useState(false)

  function handleAddEventModal() {
    setAddEventModal(() => !addEventModal)
  }

  function handleEventInfo() {
    setEventInfo(() => !eventInfo)
  }

  const getMailerInformation = async () => {
    setconnectorLoading(true)
    try {
      const {
        data: { success, data },
      } = await getMailers(companyId!)
      if (success) {
        console.log(data.isNylasActive, 'mailers')

        if (data.isNylasActive === 'nylasGoogle' || data.isNylasActive === 'nylasMicrosoft') {
          setaccountType(data.isNylasActive)
          setisUserConnected(true)
          getUserInformation()
        } else {
          toast.info(formatMessage({ id: 'Please connect your Google or Microsoft account' }), {
            autoClose: false,
            closeOnClick: true,
          })
        }
      } else {
        toast.info(formatMessage({ id: 'Please connect your Google or Microsoft account' }), {
          autoClose: false,
          closeOnClick: true,
        })
      }
    } catch (err) {
      toast.info(formatMessage({ id: 'Please connect your Google or Microsoft account' }), {
        autoClose: false,
        closeOnClick: true,
      })
    } finally {
      setconnectorLoading(false)
    }
  }

  const getUserInformation = async () => {
    setuserLoading(true)
    try {
      const {
        data: { success, error, data },
      } = await getUserInfo(companyId!)
      if (success) {
        setuserInfo(data.account.data.email)
      } else {
        toast.error(formatMessage({ id: error }))
      }
    } catch (err) {
      console.log(err)
    } finally {
      setuserLoading(false)
    }
  }

  useEffect(() => {
    getMailerInformation()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <PageTitle breadcrumbs={SharedAccessBreadCrum} description={formatMessage({ id: 'Calendar' })}>
        {formatMessage({ id: 'Shared Access' })}
      </PageTitle>
      <InfoCard2
        title={formatMessage({ id: 'Two-Way Calendar Sync' })}
        desc={formatMessage({
          id: `Integrate and sync your calendars with ${brandingConfig.brandName} for seamless, two-way synchronization, ensuring all your events and meetings are up-to-date across platforms. Collaboratively manage your schedule from a single, unified interface`,
        })}
        slug={brandingConfig.helpLinks.sharedAccessCalendar}
      />
      <Content
        addEventModal={addEventModal}
        setAddEventModal={setAddEventModal}
        handleAddEventModal={handleAddEventModal}
        eventInfo={eventInfo}
        setEventInfo={setEventInfo}
        handleEventInfo={handleEventInfo}
        userInfo={userInfo}
        eventData={eventData}
        seteventData={seteventData}
        isUserConnected={isUserConnected}
        accountType={accountType}
        userLoading={userLoading}
        connectorLoading={connectorLoading}
      />
    </>
  )
}

function Content({
  handleAddEventModal,
  addEventModal,
  setAddEventModal,
  eventInfo,
  setEventInfo,
  handleEventInfo,
  userInfo,
  eventData,
  seteventData,
  isUserConnected,
  accountType,
  userLoading,
  connectorLoading,
}: any) {
  const [allEvents, setAllEvents] = useState([])
  const { formatMessage } = useIntl()
  const [startMonthDateCalendar, setStartMonthDateCalendar] = useState<any>('')
  const [endMonthDateCalendar, setEndMonthDateCalendar] = useState<any>('')
  const [cachedEvents, setCachedEvents] = useState<any>({})
  const [cacheKey, setcacheKey] = useState('')
  const [startDay, setstartDay] = useState('')
  const [endDay, setendDay] = useState('')
  const [startTime, setStartTime] = useState('')
  const [endTime, setEndTime] = useState('')
  const [allDay, setAllDay] = useState(false)

  const convertTo12HourFormat = (dateTimeStr: string) => {
    const dateObj = new Date(dateTimeStr)
    const options: any = { hour: '2-digit', minute: '2-digit', hour12: true }
    return new Intl.DateTimeFormat(brandingConfig.defaultLocale, options).format(dateObj)
  }

  const handleSelect = (val: any) => {
    let newStartDate = val.startStr || ''
    let newEndDate = val.endStr || ''
    let newStartTime = ''
    let newEndTime = ''

    if (val.allDay && val.view.type !== 'dayGridMonth') {
      setAllDay(true)
      const endDateObj = new Date(newEndDate)
      endDateObj.setDate(endDateObj.getDate() - 1)
      newEndDate = endDateObj.toISOString().split('T')[0]

      setstartDay(newStartDate)
      setendDay(newEndDate)
      return
    }

    if (val.view.type === 'dayGridMonth') {
      const endDateObj = new Date(newEndDate)
      endDateObj.setDate(endDateObj.getDate() - 1)
      newEndDate = endDateObj.toISOString().split('T')[0]
    } else {
      newStartDate = newStartDate?.split('T')[0]
      newEndDate = newEndDate?.split('T')[0]

      newStartTime = convertTo12HourFormat(val.startStr)
      newEndTime = convertTo12HourFormat(val.endStr)
    }

    setstartDay(newStartDate)
    setendDay(newEndDate)

    console.log('full calendar val chekck', newStartTime, newEndTime)

    if (val.view.type !== 'dayGridMonth') {
      setStartTime(newStartTime)
      setEndTime(newEndTime)
    }
  }

  const handleCachedEvents = (start: any, eventObj: any, actionType: string) => {
    const cacheKey = `${start}`

    const currentCachedEvents = cachedEvents[cacheKey]

    if (currentCachedEvents) {
      switch (actionType) {
        case 'add':
          const updatedEventsAdd = [...currentCachedEvents, eventObj]
          setCachedEvents((prev: any) => ({
            ...prev,
            [cacheKey]: updatedEventsAdd,
          }))
          break
        case 'edit':
          const eventToUpdateIndex = currentCachedEvents.findIndex(
            (event: any) => event.eventId === eventObj.eventId
          )

          if (eventToUpdateIndex !== -1) {
            // Update existing event
            const updatedEventsEdit = currentCachedEvents.map((event: any) =>
              event.eventId === eventObj.eventId ? eventObj : event
            )
            setCachedEvents((prev: any) => ({
              ...prev,
              [cacheKey]: updatedEventsEdit,
            }))
          } else {
            const updatedEventsEdit = [...currentCachedEvents, eventObj]
            setCachedEvents((prev: any) => ({
              ...prev,
              [cacheKey]: updatedEventsEdit,
            }))
          }
          break
        case 'delete':
          const updatedEventsDelete = currentCachedEvents.filter(
            (event: any) => event.eventId !== eventObj.eventId
          )
          setCachedEvents((prev: any) => ({
            ...prev,
            [cacheKey]: updatedEventsDelete,
          }))
          break
        default:
          console.error('Invalid action type')
          break
      }
    } else {
      console.warn(`Cached events not found for key: ${cacheKey}`)
    }
  }

  return (
    <>
      <div className='card'>
        <div className='card-header d-md-flex justify-content-between align-items-center px-5'>
          <div className=''>
            <SwitchAccount
              userInfo={userInfo}
              isUserConnected={isUserConnected}
              accountType={accountType}
              userLoading={userLoading}
              connectorLoading={connectorLoading}
            />
          </div>
          <div className='card-toolbar w-100 w-md-auto'>
            <button
              className='btn btn-md-flex bg-primary custom-button-property text-white fw-normal w-100'
              data-kt-calendar='add'
              onClick={handleAddEventModal}
            >
              {formatMessage({ id: 'Add New Event' })}
            </button>
            {addEventModal && (
              <AddEvent
                addEventModal={addEventModal}
                setAddEventModal={setAddEventModal}
                eventData={eventData}
                seteventData={seteventData}
                setAllEvents={setAllEvents}
                allEvents={allEvents}
                handleCachedEvents={handleCachedEvents}
                cacheKey={cacheKey}
                isUserConnected={isUserConnected}
                accountType={accountType}
                defaultStartDate={startDay || ''}
                defaultEndDate={endDay || ''}
                defaultStartTime={startTime || ''}
                defaultEndTime={endTime || ''}
                setDefaultStartDate={setstartDay}
                setDefaultEndDate={setendDay}
                setDefaultStartTime={setStartTime}
                setDefaultEndTime={setEndTime}
                setDefaultAllDay={setAllDay}
                defaultAllDay={allDay || false}
              />
            )}
          </div>
        </div>
        <div className='card-body mx-4' id='kt_calendar_app'>
          <CalendarData
            eventInfo={eventInfo}
            setEventInfo={setEventInfo}
            handleEventInfo={handleEventInfo}
            handleAddEventModal={handleAddEventModal}
            eventData={eventData}
            seteventData={seteventData}
            addEventModal={addEventModal}
            setAddEventModal={setAddEventModal}
            allEvents={allEvents}
            setAllEvents={setAllEvents}
            startMonthDateCalendar={startMonthDateCalendar}
            endMonthDateCalendar={endMonthDateCalendar}
            setStartMonthDateCalendar={setStartMonthDateCalendar}
            setEndMonthDateCalendar={setEndMonthDateCalendar}
            cachedEvents={cachedEvents}
            setCachedEvents={setCachedEvents}
            handleCachedEvents={handleCachedEvents}
            setcacheKey={setcacheKey}
            cacheKey={cacheKey}
            isUserConnected={isUserConnected}
            handleSelectDays={handleSelect}
          />
        </div>
      </div>
    </>
  )
}

function CalendarData({
  eventInfo,
  setEventInfo,
  handleAddEventModal,
  eventData,
  seteventData,
  addEventModal,
  setAddEventModal,
  allEvents,
  setAllEvents,
  startMonthDateCalendar,
  endMonthDateCalendar,
  setStartMonthDateCalendar,
  setEndMonthDateCalendar,
  cachedEvents,
  setCachedEvents,
  handleCachedEvents,
  setcacheKey,
  cacheKey,
  isUserConnected,
  handleSelectDays,
}: any) {
  const { formatMessage } = useIntl()
  const { companyId } = useAuth()
  const [timeZone, settimeFormat] = useState('')
  const debounceTimeoutRef = useRef<any>(null) // eslint-disable-line

  const formatEventDescription = (desc: string) => {
    const dashPattern = /-{10,}/
    const match = desc.match(dashPattern)
    if (match) {
      const index = match.index
      return desc.substring(0, index).trim()
    }
    return desc
  }

  console.log('checking if event is updated or not', allEvents.length)

  const getAllEvents = async (startEpoch: any, endEpoch: any) => {
    try {
      const {
        data: { success, data },
      } = await getEvents(companyId!, startEpoch, endEpoch)
      if (success) {
        const timeFormat = timeZone || 'UTC+05:30'

        const formattedEvents = data.nylasEvents.data.map((event: any) => {
          const startTime = convertToLocalTime(event.when.startTime, timeFormat)
          const endTime = convertToLocalTime(event.when.endTime, timeFormat)

          return {
            title: event.title || '',
            venue: event.location || '',
            link: event?.conferencing?.details?.url || '',
            eventDesc: convertHtmlToPlainText(event?.description) || '',
            eventId: event.id,
            allDay: event.allDay || false,
            start: `${startTime.date} ${startTime.time}`,
            end: `${endTime.date} ${endTime.time}`,
          }
        })

        setCachedEvents((prev: any) => ({
          ...prev,
          [cacheKey]: formattedEvents,
        }))
        setAllEvents(formattedEvents)
        console.log(data.nylasEvents.data, formattedEvents, 'check all user event data')
      } else {
        toast.error(formatMessage({ id: 'Something went wrong.' }))
      }
    } catch (err) {
      console.log(err)
    }
  }

  const debouncedGetAllEvents = useRef(
    debounce((startEpoch: any, endEpoch: any) => {
      getAllEvents(startEpoch, endEpoch)
    }, 1000)
  ).current

  const handleEventClick = (info: any) => {
    const extendedProps = info.event._def.extendedProps
    const rangeStart = new Date(info.event._instance.range.start)
    const rangeEnd = new Date(info.event._instance.range.end)

    // Add 5 hours and 30 minutes to start and end times
    rangeStart.setHours(rangeStart.getHours() - 5)
    rangeStart.setMinutes(rangeStart.getMinutes() - 30)
    rangeEnd.setHours(rangeEnd.getHours() - 5)
    rangeEnd.setMinutes(rangeEnd.getMinutes() - 30)

    console.log('Adjusted start time:', rangeStart, 'Adjusted end time:', rangeEnd)

    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ]

    // Format end date
    const formattedEnd = `${rangeEnd.getDate()} ${monthNames[rangeEnd.getMonth()]
      } ${rangeEnd.getFullYear()}`

    // Format start date
    const formattedStart = `${rangeStart.getDate()} ${monthNames[rangeStart.getMonth()]
      } ${rangeStart.getFullYear()}`

    // Extract start and end times
    let startTime = rangeStart.toLocaleTimeString([], {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    })
    let endTime = rangeEnd.toLocaleTimeString([], {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    })

    startTime = startTime.replace(/am|pm/i, (match) => match.toUpperCase())
    endTime = endTime.replace(/am|pm/i, (match) => match.toUpperCase())

    // Format startTime - endTime
    const timeRange = `${startTime} - ${endTime}`

    const eventData = {
      title: info.event._def.title || '',
      venue: extendedProps.venue || '',
      eventId: extendedProps.eventId,
      url: extendedProps.link || '',
      eventDesc: formatEventDescription(extendedProps.eventDesc) || '',
      start: formattedStart,
      end: formattedEnd,
      startTime: timeRange,
    }

    seteventData(eventData)
    setEventInfo(true)
  }

  function handleSelect(val: any) {
    handleAddEventModal()
    handleSelectDays(val)

    console.log('full calendar val chekc', val)
  }

  const getTimezone = async () => {
    const timeZoneData = await getUserTimezone(companyId!)
    console.log('checking timezone data', timeZoneData.status)
    if (timeZoneData.status === 200) {
      console.log('checking timezone data', timeZoneData.data.data.value)
      settimeFormat(timeZoneData.data.data.value)
    } else {
      toast.error(formatMessage({ id: 'Timezone is not defined.' }))
    }
  }

  useEffect(() => {
    getTimezone()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (startMonthDateCalendar && endMonthDateCalendar && isUserConnected) {
      const startEpoch = convertToUnixEpoch(startMonthDateCalendar)
      const endEpoch = convertToUnixEpoch(endMonthDateCalendar)
      const formattedCacheKey = cacheKey

      if (cachedEvents[formattedCacheKey]) {
        setAllEvents(cachedEvents[formattedCacheKey])
        console.log('cache checking', formattedCacheKey, cachedEvents[formattedCacheKey])
      } else {
        debouncedGetAllEvents(startEpoch, endEpoch)
      }
    }
  }, [startMonthDateCalendar, endMonthDateCalendar, cacheKey, isUserConnected]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <FullCalendar
        nowIndicator
        // editable
        selectable
        select={(val) => handleSelect(val)}
        displayEventTime={false}
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        datesSet={(arg) => {
          console.log('calendar month range', arg.view.title)

          const [month, year] = arg.view.title.split(' ')
          const monthNumber = (
            '0' +
            (new Date(Date.parse(month + ' 1, 2024')).getMonth() + 1)
          ).slice(-2)
          const formattedCacheKey = `${year}-${monthNumber}`

          setStartMonthDateCalendar(arg.startStr)
          setEndMonthDateCalendar(arg.endStr)
          setcacheKey(formattedCacheKey)
        }}
        initialView='dayGridMonth'
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay',
        }}
        events={allEvents}
        eventClick={(info) => handleEventClick(info)}
      />
      {eventInfo && (
        <EventInfo
          eventInfo={eventInfo}
          eventData={eventData}
          seteventData={seteventData}
          setEventInfo={setEventInfo}
          addEventModal={addEventModal}
          setAddEventModal={setAddEventModal}
          setAllEvents={setAllEvents}
          handleCachedEvents={handleCachedEvents}
          cacheKey={cacheKey}
          isUserConnected={isUserConnected}
          timeZone={timeZone}
        />
      )}
    </>
  )
}

function AddEvent({
  addEventModal,
  setAddEventModal,
  eventData,
  seteventData,
  setAllEvents,
  allEvents,
  handleCachedEvents,
  cacheKey,
  isUserConnected,
  accountType,
  defaultStartDate,
  defaultEndDate,
  defaultStartTime,
  defaultEndTime,
  setDefaultStartDate,
  setDefaultEndDate,
  setDefaultStartTime,
  setDefaultEndTime,
  setDefaultAllDay,
  defaultAllDay,
}: any) {
  console.log('checking whoel event data', eventData)
  const { companyId, currentUser } = useAuth()
  const { formatMessage } = useIntl()
  const [eventName, setEventName] = useState(eventData?.title || '')
  const [venue, setVenue] = useState(eventData?.venue || '')
  const [link, setLink] = useState(
    eventData?.url
      ? eventData?.url
      : accountType === 'nylasGoogle'
        ? 'https://meet.google.com/'
        : 'https://teams.microsoft.com/l/meetup-join'
  )
  const [eventDescription, setEventDescription] = useState(eventData?.eventDesc || '')
  const [startDate, setStartDate] = useState(defaultStartDate)
  const [endDate, setEndDate] = useState(defaultEndDate)
  const [allDay, setAllDay] = useState(defaultAllDay || false)
  const [timeFormat, settimeFormat] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [eventNameError, setEventNameError] = useState('')
  const [dateTimeError, setDateTimeError] = useState('')
  const [startTime, setStartTime] = useState(defaultStartTime)
  const [endTime, setEndTime] = useState(defaultEndTime)
  const [endTimeOptions, setEndTimeOptions] = useState<any>(
    getEndTimes(startDate, endDate, startTime)
  )

  const handleStartTimeChange = (e: any) => {
    setStartTime(e)
  }

  const handleEndTimeChange = (value: any) => {
    const rr = value.split(' (')[0]
    const endTimeDate = timeToDate(rr)
    const startTimeDate = timeToDate(startTime)

    if (endTimeDate < startTimeDate && startDate === endDate) {
      const newEndDate = new Date(new Date(endDate).setDate(new Date(endDate).getDate() + 1))
      setEndDate(newEndDate.toISOString().split('T')[0])
    }

    setEndTime(value.split(' (')[0])
  }

  const validateFields = () => {
    let valid = true
    if (eventName === '') {
      setEventNameError(formatMessage({ id: 'Event name is required.' }))
      valid = false
    } else {
      setEventNameError('')
    }

    if (!allDay && (!startDate || !endDate || !startTime || !endTime)) {
      setDateTimeError(formatMessage({ id: 'Please select valid start and end dates/times.' }))
      valid = false
    } else if (allDay && (!startDate || !endDate)) {
      setDateTimeError(formatMessage({ id: 'Please select valid start and end dates.' }))
      valid = false
    } else {
      setDateTimeError('')

      const startDateTime = createDateFromTimeString(startDate, startTime)
      const endDateTime = createDateFromTimeString(endDate, endTime)

      if (endDateTime < startDateTime) {
        setDateTimeError(formatMessage({ id: 'Event must end after it starts.' }))
        valid = false
      } else if (startDate === endDate && endDateTime <= startDateTime) {
        setDateTimeError(formatMessage({ id: 'Event must end after it starts.' }))
        valid = false
      } else {
        setDateTimeError('')
      }
    }

    return valid
  }

  const onSubmitEvent = async () => {
    if (!validateFields()) {
      return
    }

    setIsSubmitting(true)

    try {
      let startUnixEpoch, endUnixEpoch
      let payload = {}

      if (allDay && startDate && endDate) {
        const start = new Date(`${startDate}T00:10:00`)
        const end = new Date(`${endDate}T23:59:59`)
        startUnixEpoch = Math.floor(start.getTime() / 1000)
        endUnixEpoch = Math.floor(end.getTime() / 1000)

        payload = {
          title: eventName,
          location: venue,
          description: eventDescription,
          startTime: startUnixEpoch,
          endTime: endUnixEpoch,
          link: link,
        }
      } else if (!allDay && startDate && endDate && startTime && endTime) {
        const convertTo24HourFormat = (timeStr: string) => {
          const [time, period] = timeStr.split(' ')
          let [hours, minutes] = time.split(':').map(Number)
          if (period === 'PM' && hours !== 12) {
            hours += 12
          } else if (period === 'AM' && hours === 12) {
            hours = 0
          }
          return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
        }

        const start24HourTime = convertTo24HourFormat(startTime)
        const end24HourTime = convertTo24HourFormat(endTime)

        // Combine date and time to form ISO date strings
        const startDateTimeString = `${startDate}T${start24HourTime}`
        const endDateTimeString = `${endDate}T${end24HourTime}`

        const startDateTime = new Date(startDateTimeString)
        const endDateTime = new Date(endDateTimeString)

        startUnixEpoch = Math.floor(startDateTime.getTime() / 1000)
        endUnixEpoch = Math.floor(endDateTime.getTime() / 1000)

        payload = {
          title: eventName,
          location: venue,
          description: eventDescription,
          startTime: startUnixEpoch,
          endTime: endUnixEpoch,
          link: link,
          // localStartTime: startLocalTime,
          // localEndTime: endLocalTime,
        }
      } else {
        toast.error(formatMessage({ id: 'Please select valid start and end dates/times.' }))
        return
      }

      let apiCall
      if (eventData?.eventId) {
        apiCall = updateEvent(companyId!, payload, eventData.eventId)
      } else {
        apiCall = createEvent(companyId!, payload)
      }

      const {
        data: { success, data, errors },
      } = await apiCall

      if (success) {
        const newEvent = {
          title: data.event.data.title || '',
          venue: data.event.data.location || '',
          link: data.event.data?.conferencing?.details?.url || '',
          eventDesc: convertHtmlToPlainText(data.event.data?.description) || '',
          eventId: data.event.data.id,
          allDay: data.event.data.allDay || false,
          start: `${convertToLocalTime(data?.event?.data?.when?.startTime, timeFormat).date} ${convertToLocalTime(data?.event?.data?.when?.startTime, timeFormat).time
            }`,
          end: `${convertToLocalTime(data.event.data.when.endTime, timeFormat).date} ${convertToLocalTime(data.event.data.when.endTime, timeFormat).time
            }`,
        }

        if (eventData?.eventId) {
          toast.success(formatMessage({ id: 'Event updated successfully.' }))
          setAllEvents(
            allEvents.map((event: any) => (event.eventId === newEvent.eventId ? newEvent : event))
          )
          handleCachedEvents(startDate.substring(0, 7), newEvent, 'edit')
          cacheKey !== startDate.substring(0, 7) &&
            handleCachedEvents(cacheKey, { eventId: eventData.eventId }, 'delete')

          const startMonth = startDate.substring(0, 7)
          const endMonth = endDate.substring(0, 7)
          if (startMonth !== endMonth) {
            handleCachedEvents(endMonth, newEvent, 'edit')
          }
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.SharedAccessEventUpdatedSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                title: data.event.data.title || '',
                venue: data.event.data.location || '',
                link: data.event.data?.conferencing?.details?.url || '',
                event_description: convertHtmlToPlainText(data.event.data?.description) || '',
                event_id: data.event.data.id,
                all_day: data.event.data.allDay || false,
                start_date: `${convertToLocalTime(data?.event?.data?.when?.startTime, timeFormat).date
                  } ${convertToLocalTime(data?.event?.data?.when?.startTime, timeFormat).time}`,
                end_date: `${convertToLocalTime(data.event.data.when.endTime, timeFormat).date} ${convertToLocalTime(data.event.data.when.endTime, timeFormat).time
                  }`,
                user_id: currentUser?.userId,
                email: currentUser?.email,
              },
            },
          })
        } else {
          toast.success(formatMessage({ id: 'Event created successfully.' }))
          setAllEvents([...allEvents, newEvent])
          handleCachedEvents(startDate.substring(0, 7), newEvent, 'add')

          const startMonth = startDate.substring(0, 7)
          const endMonth = endDate.substring(0, 7)
          if (startMonth !== endMonth) {
            handleCachedEvents(endMonth, newEvent, 'add')
          }
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.SharedAccessEventCreateSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                title: data.event.data.title || '',
                venue: data.event.data.location || '',
                link: data.event.data?.conferencing?.details?.url || '',
                event_description: convertHtmlToPlainText(data.event.data?.description) || '',
                event_id: data.event.data.id,
                all_day: data.event.data.allDay || false,
                start_date: `${convertToLocalTime(data?.event?.data?.when?.startTime, timeFormat).date
                  } ${convertToLocalTime(data?.event?.data?.when?.startTime, timeFormat).time}`,
                end_date: `${convertToLocalTime(data.event.data.when.endTime, timeFormat).date} ${convertToLocalTime(data.event.data.when.endTime, timeFormat).time
                  }`,
                user_id: currentUser?.userId,
                email: currentUser?.email,
              },
            },
          })
        }
        // Reset form fields
        seteventData({})
        setEventName('')
        setVenue('')
        setLink('')
        setEventDescription('')
        setStartDate('')
        setStartTime('')
        setEndDate('')
        setEndTime('')
        setAllDay(false)
        // setAddEventModal(false)
      } else {
        console.log('error for event add', errors)
        toast.error(formatMessage({ id: `${errors[0]}` }))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.SharedAccessEventCreateFailed,
            action: 'normal',
            metadata: {
              company_id: companyId,
              title: data.event.data.title || '',
              venue: data.event.data.location || '',
              link: data.event.data?.conferencing?.details?.url || '',
              eventDesc: convertHtmlToPlainText(data.event.data?.description) || '',
              eventId: data.event.data.id,
              allDay: data.event.data.allDay || false,
              start: `${convertToLocalTime(data?.event?.data?.when?.startTime, timeFormat).date} ${convertToLocalTime(data?.event?.data?.when?.startTime, timeFormat).time
                }`,
              end: `${convertToLocalTime(data.event.data.when.endTime, timeFormat).date} ${convertToLocalTime(data.event.data.when.endTime, timeFormat).time
                }`,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              error: errors[0],
            },
          },
        })
        return
      }
      seteventData({})
      setDefaultStartDate('')
      setDefaultEndDate('')
      setDefaultStartTime('')
      setDefaultEndTime('')
      setDefaultAllDay(false)
      setAddEventModal(false)
    } catch (err) {
      console.error(err)
      toast.error(formatMessage({ id: `An error occurred while processing your request.${err}` }))
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.SharedAccessEventCreateFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err,
          },
        },
      })
    } finally {
      setIsSubmitting(false)
    }
  }

  const getTimezone = async () => {
    const timeZoneData = await getUserTimezone(companyId!)
    console.log('checking timezone data', timeZoneData.status)
    if (timeZoneData.status === 200) {
      console.log('checking timezone data', timeZoneData.data.data.value)
      settimeFormat(timeZoneData.data.data.value)
    } else {
      toast.error(formatMessage({ id: 'Timezone is not defined.' }))
    }
  }

  const formatDate = (dateStr: string) => {
    const [day, month, year] = dateStr.split(' ')
    const monthIndex = new Date(Date.parse(month + ' 1, 2012')).getMonth() + 1 // Convert month name to number
    return `${year}-${String(monthIndex).padStart(2, '0')}-${String(day).padStart(2, '0')}`
  }

  const convertTo12HourFormat = (date: Date) => {
    let hours = date.getHours()
    const minutes = date.getMinutes()
    const period = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12 || 12
    const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
      2,
      '0'
    )} ${period}`
    return formattedTime
  }
  const createDateFromTimeString = (dateStr: string, timeStr: string) => {
    const date = new Date(dateStr)
    const [time, period] = timeStr.split(' ')
    let [hours, minutes] = time.split(':').map(Number)
    if (period.toLowerCase() === 'pm' && hours !== 12) {
      hours += 12
    } else if (period.toLowerCase() === 'am' && hours === 12) {
      hours = 0
    }
    date.setHours(hours)
    date.setMinutes(minutes)
    return date
  }

  useEffect(() => {
    if (!eventData.eventId) {
      const now = new Date()
      const roundedTime = roundToNearest15Minutes(now)
      const startTimeOption = defaultStartTime || convertTo12HourFormat(roundedTime)

      const currentDate = now.toISOString().split('T')[0] // YYYY-MM-DD
      const thirtyMinutesLater = new Date(roundedTime.getTime() + 30 * 60 * 1000)
      const endTime = defaultEndTime || convertTo12HourFormat(thirtyMinutesLater)

      console.log('use state add event', startTimeOption, endTime)

      setStartDate(defaultStartDate || currentDate)
      setStartTime(startTimeOption)
      setEndDate(defaultEndDate || currentDate)
      setEndTime(endTime)
    } else {
      const startDate = formatDate(eventData.start || '')
      const endDate = formatDate(eventData.end || '')
      const startTime = eventData.startTime.split(' - ')[0] || ''
      const endTime = eventData.startTime.split(' - ')[1] || ''

      const startDateTime = createDateFromTimeString(startDate, startTime)
      const endDateTime = createDateFromTimeString(endDate, endTime)

      setStartDate(startDate)
      setStartTime(convertTo12HourFormat(startDateTime))
      setEndDate(endDate)
      setEndTime(convertTo12HourFormat(endDateTime))
    }
  }, [eventData]) // eslint-disable-line

  useEffect(() => {
    getTimezone()
  }, []) // eslint-disable-line

  useEffect(() => {
    console.log('use state add event', 'Start time updated:', startTime)
    const currentDate = new Date().toISOString().split('T')[0]
    const effectiveStartDate = startDate || currentDate
    const effectiveEndDate = endDate || currentDate

    if (startTime && effectiveStartDate && effectiveEndDate) {
      const endTimes = getEndTimes(effectiveStartDate, effectiveEndDate, startTime)

      setEndTimeOptions(endTimes)

      console.log('use state add event', 'chekc dddddd', endTimes, startDate, endDate, startTime)
    }
  }, [startTime, startDate, endDate]) // eslint-disable-line

  useEffect(() => {
    const addThirtyMinutes = (time: any) => {
      const [timePart, period] = time.split(' ')
      let [hours, minutes] = timePart.split(':').map(Number)

      if (period === 'PM' && hours !== 12) {
        hours += 12
      } else if (period === 'AM' && hours === 12) {
        hours = 0
      }

      const date = new Date()
      date.setHours(hours)
      date.setMinutes(minutes + 30)

      const newHours = date.getHours()
      const newMinutes = date.getMinutes().toString().padStart(2, '0')
      const newPeriod = newHours >= 12 ? 'PM' : 'AM'
      const adjustedHours = newHours % 12 || 12

      return `${adjustedHours}:${newMinutes} ${newPeriod}`
    }
    if (!eventData.eventId && startTime) {
      const newEndTime = addThirtyMinutes(startTime)
      console.log('use state add event', 'checking new 30', newEndTime, startTime)
      setEndTime(defaultEndTime || newEndTime)
    }
  }, []) // eslint-disable-line

  return (
    <Modal
      show={addEventModal}
      onHide={() => {
        if (!isSubmitting) {
          setDefaultStartDate('')
          setDefaultEndDate('')
          setDefaultStartTime('')
          setDefaultEndTime('')
          setDefaultAllDay(false)
          setAddEventModal(false)
          seteventData({})
        }
      }}
      size='lg'
    >
      <Form>
        <Modal.Header closeButton>
          <h2>
            {eventData?.eventId
              ? formatMessage({ id: 'Update Event' })
              : formatMessage({ id: 'Add a New Event' })}
          </h2>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div>
              <InfoCard2
                title='Integrated Calendar Management'
                desc={`Manage your schedule, conduct meetings, and organize events seamlessly from one place with ${brandingConfig.brandName}'s integrated calendar, eliminating the need to juggle between platforms.`}
                slug={brandingConfig.helpLinks.sharedAccessCalenderNewEvent}
              />
            </div>
            <div className='d-flex justify-content-between mt-2' style={{ gap: '14px' }}>
              <div className='d-flex flex-column' style={{ width: '-webkit-fill-available' }}>
                <label htmlFor='eventName' className='required'>
                  {formatMessage({ id: 'Event Name' })}
                </label>
                <input
                  className='form-control'
                  type='text'
                  value={eventName}
                  onChange={(e) => setEventName(e.target.value)}
                />
                {eventNameError && (
                  <div className='text-danger'>{formatMessage({ id: eventNameError })}</div>
                )}
              </div>
              <div className='d-flex flex-column ' style={{ width: '-webkit-fill-available' }}>
                <label htmlFor='venue'>{formatMessage({ id: 'Venue' })}</label>
                <input
                  className='form-control'
                  type='text'
                  value={venue}
                  onChange={(e) => setVenue(e.target.value)}
                />
              </div>
            </div>
            <div className='d-flex flex-column mt-2' style={{ width: '-webkit-fill-available' }}>
              <label className='required' htmlFor='link'>
                {formatMessage({ id: 'Meeting Link' })}
              </label>
              <input
                className='form-control'
                type='text'
                required={true}
                value={link}
                onChange={(e) => setLink(e.target.value)}
              />
            </div>
            <div className='mt-2'>
              <label htmlFor='eventDesc'>{formatMessage({ id: 'Event Description' })}</label>
              <textarea
                className='form-control'
                name='eventDesc'
                value={eventDescription}
                onChange={(e) => setEventDescription(e.target.value)}
              ></textarea>
            </div>

            <div className='d-flex flex-column  mt-2'>
              <label className='required'>{formatMessage({ id: 'Event Time' })}</label>
              <div className='d-flex flex-column flex-md-row flex-wrap align-items-center'>
                <div className='d-flex w-100 w-md-auto align-items-center ms-1 ms-md-0 my-md-0 my-4 allDay'>
                  <label className='d-flex align-items-center'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      checked={allDay}
                      onChange={(e) => setAllDay(e.target.checked)}
                    />
                  </label>
                  <span className='mx-0 ms-2'>{formatMessage({ id: 'All Day' })}</span>
                </div>

                <div className='d-flex flex-md-row flex-column ms-md-3 m-0 w-md-75 w-100  date-time-container'>
                  <div className={'d-flex flex-md-row flex-column gap-2 w-100 w-md-auto'}>
                    <Modal.Dialog className='m-0 mx-1'>
                      <input
                        type='date'
                        className='form-control w-auto'
                        style={{
                          fontFamily: 'Poppins',
                          fontWeight: 400,
                          fontSize: '13px',
                          lineHeight: '20px',
                          color: '#383940',
                        }}
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                      />
                    </Modal.Dialog>

                    {!allDay && (
                      <Modal.Dialog className='m-0 mx-1'>
                        <EditableDropdownInput
                          options={timeOptions}
                          value={startTime}
                          onChange={handleStartTimeChange}
                        />
                      </Modal.Dialog>
                    )}
                  </div>

                  <div
                    className='d-flex m-2 align-items-center justify-content-center w-100 w-md-auto text-center'
                    style={{ boxShadow: '0' }}
                  >
                    {formatMessage({ id: 'to' })}
                  </div>

                  <div className='d-flex flex-md-row flex-column w-100 w-md-auto gap-2'>
                    {!allDay && (
                      <Modal.Dialog className='m-0 mx-1'>
                        <EditableDropdownInput
                          options={endTimeOptions}
                          value={endTime}
                          onChange={handleEndTimeChange}
                        />
                      </Modal.Dialog>
                    )}

                    <Modal.Dialog className='m-0 mx-1'>
                      <input
                        type='date'
                        className='form-control w-auto'
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        style={{
                          fontFamily: 'Poppins',
                          fontWeight: 400,
                          fontSize: '13px',
                          lineHeight: '20px',
                          color: '#383940',
                        }}
                      />
                    </Modal.Dialog>
                  </div>
                </div>
              </div>
              {dateTimeError && (
                <div className='text-danger'>{formatMessage({ id: dateTimeError })}</div>
              )}
            </div>
            <div className='d-flex flex-column mt-4' style={{ width: '-webkit-fill-available' }}>
              <p
                style={{
                  fontFamily: 'Poppins',
                  fontWeight: '400',
                  fontSize: '13px',
                  lineHeight: '20px',
                }}
              >
                {timeFormat &&
                  formatMessage({
                    id: `Your current Timezone is ${timeFormat}. `,
                  })}
                <span style={{ color: '#4776E6' }}>
                  <Link to='/setting/user-settings?tab=locale'>
                    {formatMessage({ id: 'Click here' })}{' '}
                  </Link>
                </span>
                {formatMessage({ id: 'To change timezone.' })}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className='p-0'>
          <div className='d-flex flex-md-row flex-column gap-3 m-5 w-100 justify-content-md-end'>
            <button
              type='button'
              className='btn bg-light custom-button-property text-muted fw-normal w-100 w-md-auto font-size-13 order-md-1 order-2'
              onClick={() => {
                if (!isSubmitting) {
                  setAddEventModal(false)
                  setDefaultStartDate('')
                  setDefaultAllDay(false)
                  setDefaultEndDate('')
                  setDefaultStartTime('')
                  setDefaultEndTime('')
                  seteventData({})
                }
              }}
              disabled={isSubmitting}
            >
              {formatMessage({ id: 'Cancel' })}
            </button>
            <button
              className='btn bg-primary custom-button-property text-white fw-normal w-100 w-md-auto font-size-13 me-5 order-md-2 order-1'
              disabled={!isUserConnected || isSubmitting}
              onClick={(e) => {
                e.preventDefault()
                onSubmitEvent()
              }}
            >
              <span className='indicator-label font-size-13 p-0'>
                {isSubmitting
                  ? eventData?.eventId
                    ? formatMessage({ id: 'Updating...' })
                    : formatMessage({ id: 'Submitting...' })
                  : eventData?.eventId
                    ? formatMessage({ id: 'Update' })
                    : formatMessage({ id: 'Submit' })}
              </span>
            </button>
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

function EventInfo({
  eventInfo,
  eventData,
  seteventData,
  setEventInfo,
  handleEventInfo,
  addEventModal,
  setAddEventModal,
  setAllEvents,
  handleCachedEvents,
  cacheKey,
  isUserConnected,
  timeZone,
}: any) {
  const { formatMessage } = useIntl()
  const { companyId, currentUser } = useAuth()
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)

  const handleDeleteEvent = async (eventId: any) => {
    setIsDeleting(true)
    try {
      const {
        data: { success },
      } = await deleteEvent(companyId!, eventId)

      if (success) {
        toast.success(formatMessage({ id: 'Event deleted successfully.' }))
        setAllEvents((prevEvents: any) =>
          prevEvents.filter((event: any) => event.eventId !== eventId)
        )
        // handleCachedEvents(cacheKey, {eventId: eventId}, 'delete')
        // Check if event spans multiple months
        const startDate = new Date(eventData.start)
        const endDate = new Date(eventData.end)

        const startMonth = `${startDate.getFullYear()}-${('0' + (startDate.getMonth() + 1)).slice(
          -2
        )}`
        const endMonth = `${endDate.getFullYear()}-${('0' + (endDate.getMonth() + 1)).slice(-2)}`

        // Handle cache for start month
        handleCachedEvents(startMonth, { eventId: eventId }, 'delete')
        handleCachedEvents(cacheKey, { eventId: eventId }, 'delete')

        // Handle cache for end month if different from start month
        if (startMonth !== endMonth) {
          handleCachedEvents(endMonth, { eventId: eventId }, 'delete')
        }
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.SharedAccessEventDeletedSuccessful,
            action: 'normal',
            metadata: {
              company_id: companyId,
              event_id: eventId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
            },
          },
        })
      } else {
        toast.error(formatMessage({ id: 'Something Went Wrong.' }))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.SharedAccessEventDeletedSuccessful,
            action: 'normal',
            metadata: {
              company_id: companyId,
              event_id: eventId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              error: formatMessage({ id: 'Something Went Wrong.' }),
            },
          },
        })
      }
    } catch (err) {
      console.error('Error deleting event:', err)
      toast.error(formatMessage({ id: 'Failed to delete event.' }))
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.SharedAccessEventDeletedSuccessful,
          action: 'normal',
          metadata: {
            company_id: companyId,
            event_id: eventId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err,
          },
        },
      })
    } finally {
      setIsDeleting(false)
      setShowDeleteConfirm(false)
      seteventData({})
      setEventInfo(false)
    }
  }

  const handleEditEvent = () => {
    setAddEventModal(true)
    setEventInfo(false)
  }

  const formatTimeZone = (timeZone: any) => {
    const match = timeZone.match(/UTC([+-]\d{2}:\d{2})/)
    if (match) {
      return `(UTC${match[1]} hours)`
    }
    return timeZone
  }
  console.log('event data typing', eventData)
  return (
    <>
      <Modal
        show={eventInfo}
        onHide={() => {
          setEventInfo(false)
          seteventData({})
        }}
        size='lg'
      >
        {/* <Modal.Header closeButton></Modal.Header> */}
        <Modal.Body>
          <div className='d-flex justify-content-between'>
            <div className='d-flex justify-content-start align-items-center'>
              <div
                style={{
                  height: '16px',
                  width: '16px',
                  background: '#7239EA',
                  borderRadius: '54px',
                  margin: '6px 6px 6px 0',
                }}
              ></div>
              <div>
                <h2 className='m-0'>{eventData?.title}</h2>
              </div>
            </div>
            <div className='d-flex justify-content-end align-items-center'>
              <button
                className='btn btn-sm btn-icon btn-light btn-active-light-primary me-2'
                data-bs-toggle='tooltip'
                data-bs-dismiss='click'
                data-bs-placement='top'
                title='Edit'
                type='button'
                disabled={!isUserConnected}
                onClick={() => handleEditEvent()}
              >
                <img
                  className='inbox-prev-next-logo'
                  src={Edit}
                  alt={formatMessage({ id: 'edit' })}
                />
              </button>
              <button
                className='btn btn-sm btn-icon btn-light btn-active-light-primary me-5'
                data-bs-toggle='tooltip'
                data-bs-dismiss='click'
                data-bs-placement='top'
                title='Delete'
                type='button'
                disabled={!isUserConnected}
                onClick={() => {
                  setShowDeleteConfirm(true)
                }}
              >
                {/* <img src={Delete} alt={formatMessage({ id: 'delete' })} /> */}
                <img
                  className='inbox-prev-next-logo'
                  src={Delete}
                  alt={formatMessage({ id: 'delete' })}
                />
              </button>
              <button
                type='button'
                className='border-0 bg-transparent p-0 align-self-start'
                onClick={() => {
                  setEventInfo(false)
                  seteventData({})
                }}
              >
                <img
                  style={{ height: '20px', width: '20px' }}
                  src={Closebtn}
                  alt={formatMessage({ id: 'Close-button' })}
                  className='inbox-prev-next-logo'
                />
              </button>
            </div>
          </div>

          <div style={{ margin: eventData?.eventDesc?.length > 1 ? '24px 0' : '4px 0px' }}>
            <p style={{ fontWeight: '400', fontSize: '12px', lineHeight: '18px' }}>
              {eventData?.eventDesc}
            </p>
          </div>

          <div className='d-flex justify-content-between w-75'>
            <div className='d-flex flex-column justify-content-between'>
              <div style={{ marginBottom: '14px' }}>
                <h3
                  style={{
                    fontSize: '13px',
                    fontWeight: '500',
                    lineHeight: '20px',
                    textAlign: 'left',
                  }}
                >
                  {formatMessage({ id: 'Start Date' })}
                </h3>
                <h1
                  style={{
                    fontSize: '16px',
                    fontWeight: '400',
                    lineHeight: '20px',
                    textAlign: 'left',
                  }}
                >
                  {eventData?.start}
                </h1>
              </div>
              <div style={{ marginBottom: '14px' }}>
                <h3
                  style={{
                    fontSize: '13px',
                    fontWeight: '500',
                    lineHeight: '20px',
                    textAlign: 'left',
                  }}
                >
                  {formatMessage({ id: 'Time' })}
                </h3>
                <h1
                  style={{
                    fontSize: '16px',
                    fontWeight: '400',
                    lineHeight: '20px',
                    textAlign: 'left',
                  }}
                >
                  {eventData?.startTime + ` ${formatTimeZone(timeZone)}`}
                </h1>
              </div>
            </div>
            <div className='d-flex flex-column justify-content-between'>
              <div style={{ marginBottom: '14px' }}>
                <h3
                  style={{
                    fontSize: '13px',
                    fontWeight: '500',
                    lineHeight: '20px',
                    textAlign: 'left',
                  }}
                >
                  {formatMessage({ id: 'End Date' })}
                </h3>
                <h1
                  style={{
                    fontSize: '16px',
                    fontWeight: '400',
                    lineHeight: '20px',
                    textAlign: 'left',
                  }}
                >
                  {eventData?.end}
                </h1>
              </div>
              <div style={{ marginBottom: '14px' }}>
                <h3
                  style={{
                    fontSize: '13px',
                    fontWeight: '500',
                    lineHeight: '20px',
                    textAlign: 'left',
                  }}
                >
                  {formatMessage({ id: 'Venue' })}
                </h3>
                <h1
                  style={{
                    fontSize: '16px',
                    fontWeight: '400',
                    lineHeight: '20px',
                    textAlign: 'left',
                  }}
                >
                  {eventData?.venue === '' ? formatMessage({ id: 'No Venue' }) : eventData.venue}
                </h1>
              </div>
            </div>
          </div>
          {eventData?.url && (
            <div style={{ width: '100%', overflowX: 'hidden' }}>
              <h1
                style={{
                  fontSize: '13px',
                  fontWeight: '500',
                  lineHeight: '20px',
                  textAlign: 'left',
                  width: '100%',
                }}
              >
                {formatMessage({ id: 'Meeting Link' })}
              </h1>
              <Link
                className='text-dark'
                style={{ fontSize: '13px', lineHeight: '20px', width: '100%' }}
                to=''
              >
                {eventData?.url}
              </Link>
            </div>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        show={showDeleteConfirm}
        style={{ marginTop: '5%' }}
        onHide={() => {
          if (!isDeleting) {
            setShowDeleteConfirm(false)
          }
        }}
        // size='sm'
        centered
      >
        <Modal.Body>
          <h5>{formatMessage({ id: 'Are you sure you want to delete this event?' })}</h5>
          <div className='d-flex justify-content-end mt-4'>
            <button
              type='button'
              className='btn btn-bg-secondary fw-normal w-50 w-md-auto font-size-13'
              style={{ marginRight: '10px' }}
              onClick={() => {
                if (!isDeleting) {
                  setShowDeleteConfirm(false)
                }
              }}
              disabled={isDeleting}
            >
              {formatMessage({ id: 'Cancel' })}
            </button>
            <button
              className='btn btn-danger fw-normal w-50 w-md-auto font-size-13 me-5 '
              onClick={() => handleDeleteEvent(eventData.eventId)}
              disabled={isDeleting}
            >
              {isDeleting ? formatMessage({ id: 'Deleting...' }) : formatMessage({ id: 'Delete' })}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
